import { createFlagsScheme, schema } from '@funtech-int/yango-shared';

import { ShowcaseId } from '@/shared/lib/analytics/showcase';

const BENEFIT_TYPES = ['family', 'watch', 'download', 'taxi', 'vibe'] as const;

export type BenefitType = (typeof BENEFIT_TYPES)[number];

export const remoteConfigScheme = createFlagsScheme({
    loginwall_config: schema
        .create({
            backgroundImageUrl: schema.mapOf(schema.string).optional(),
            title: schema.mapOf(schema.string).optional(),
            subtitle: schema.mapOf(schema.string).optional(),
            loginwallShowcaseId: schema.enum(Object.values(ShowcaseId)).optional(),
        })
        .optional(),
    onboarding_config: schema
        .create({
            isInfoBlocksSectionEnabled: schema.boolean.optional(),
            isChannelsInfoBlockEnabled: schema.boolean.optional(),
            isMusicLandingNavigationEnabled: schema.boolean.optional(),
            isYasminaLandingNavigationEnabled: schema.boolean.optional(),
            isYasminaInfoBlockEnabled: schema.boolean.optional(),
            benefitsInfoBlock: schema.arrayOf(schema.enum(BENEFIT_TYPES)).optional(),
        })
        .optional(),
});
